import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';

import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

const revertFormalNoticeVariablesSchema = z.object({
  id: z.string(),
});

export type RevertFormalNoticeVariables = z.infer<typeof revertFormalNoticeVariablesSchema>;

export async function revertFormalNoticeFn(
  axiosInstance: Promise<AxiosInstance>,
  data: RevertFormalNoticeVariables,
) {
  const instance = await axiosInstance;

  return instance.put(
    `invoices/${data.id}/revert_formal_notice`,
    revertFormalNoticeVariablesSchema.parse(data),
  );
}

export function useRevertFormalNotice() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, RevertFormalNoticeVariables>({
    mutationFn: variables => revertFormalNoticeFn(axiosInstance, variables),
    onSuccess: () => {},
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    RevertFormalNoticeVariables,
    'revertFormalNotice'
  >('revertFormalNotice', mutation);
}
